<template>
  <v-app>
    <v-app-bar dense flat app :color="getColor()" class="white--text">
      <h6 v-if="mobile" v-on:click="goToHome"><v-icon small dark>{{mdiCards}}</v-icon> Let's vote</h6>
      <h3 v-else v-on:click="goToHome"><v-icon dark>{{mdiCards}}</v-icon> Let's vote</h3>
      <v-btn v-if="inTable()" style="margin-left: 15px; color: white;" color="pink" x-small 
        v-on:click="redirectToNext()">Try the new version</v-btn>
      <v-spacer></v-spacer>      
      
      <v-img id="santa" v-if="inTable() && nearChristmas()" :max-width="mobile ? '70px' : '120px'" v-bind:src="getSantaImage()"></v-img>
      <v-img id="bunny" v-if="inTable() && nearEaster()" :max-width="mobile ? '20px' : '38px'" v-bind:src="getBunnyImage()"></v-img>
      <v-img id="hidebunny" v-if="inTable() && itsEaster()" :max-width="'50px'" v-bind:src="getBunnyHideImage()"></v-img>

      <v-btn class="holidaysBtn" icon :small="mobile" dark v-if="inTable() && nearChristmas()" v-on:click="toggleChristmas()"><v-icon>{{mdiSnowflake}}</v-icon></v-btn>
      <v-btn class="holidaysBtn" icon :small="mobile" dark v-if="inTable() && nearEaster()" v-on:click="toggleEaster()"><v-icon>{{mdiEggEaster}}</v-icon></v-btn>
      <v-btn icon :small="mobile" dark v-if="inTable()" v-on:click="toggleHistory()"><v-icon>{{mdiHistory}}</v-icon></v-btn>
      <v-btn icon :small="mobile" dark v-if="inTable()" v-on:click="toggleChat()"><v-icon>{{mdiForum}}</v-icon><v-badge left dot :content="this.$store.state.unreadMessages" v-if="this.$store.state.unreadMessages > 0" color="red"></v-badge></v-btn>
      <v-btn icon :small="mobile" dark v-if="inTable()" v-on:click="toggleSettings()"><v-icon>{{mdiDramaMasks}}</v-icon></v-btn>
      <v-btn icon :small="mobile" dark v-if="inTable()" v-on:click="copyToClipboard"><v-icon>{{mdiShareVariant}}</v-icon></v-btn>

      <h5 v-if="!inTable()">
        <a id="about" target="_blank" href="https://serafo27.github.io/lets-vote/">About</a>
      </h5>
    </v-app-bar>

    <v-main v-bind:class="{ easter: itsEaster() }">

      <div class="wrapper" v-if="inTable() && itsChristmas()">
          <div class="snow layer1 a"></div>
          <div class="snow layer1"></div> 
          <div class="snow layer2 a"></div>
          <div class="snow layer2"></div>
          <div class="snow layer3 a"></div>
          <div class="snow layer3"></div>
      </div>

      <v-container fluid>
        <History v-if="this.$store.state.drawer" :history="history"/>

        <router-view></router-view>
        
        <Presentation v-if="!inTable()" />
        <v-snackbar id="copied" top right :color="getColor()" v-model="snackbar" :timeout="timeout">
          Room link copied to clipboard
          
          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbar = false">
              <v-icon>{{mdiClose}}</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <Stats v-if="!inTable()" />
        <br/>
        <CarbonBadge v-if="!inTable()" />

        <v-snackbar bottom right :value="updateExists" :timeout="-1" color="pink">
          An update is available
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="refreshApp">Update</v-btn>
          </template>
        </v-snackbar>

      </v-container>

      

      <div style="position: fixed; bottom: 15px; left: 15px; z-index: 100;">
        <v-btn fab small color=primary>
          <a href="https://paypal.me/serafozen" target=”_blank”>
            <img src="https://cdn.buymeacoffee.com/widget/assets/coffee%20cup.svg" alt="Buy Me A Coffee" style="height: 30px; width: 30px; margin: 0; padding: 0; margin-top: 5px;" />
          </a>
        </v-btn>
      </div>

    </v-main>

    <v-footer v-if="!inTable()" padless color=white app>
      <v-row justify="center" no-gutters>
      <v-col class="py-4 text-center grey--text" cols="12">
        <div class="text-caption">Made by <a target="_blank" rel="noreferrer" href="http://www.serafinodangelillo.it">Heptartle</a></div>
      </v-col>
    </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import router from './router'
import Presentation from './components/presentation/Presentation'
import CarbonBadge from './components/CarbonBadge'
import Stats from './components/Stats'
import History from './components/History'
import { mdiSnowflake, mdiShareVariant, mdiCards, mdiClose, mdiHistory, mdiForum, mdiDramaMasks, mdiEggEaster } from '@mdi/js'
import update from './mixins/update'

export default {
  data () {
    return {
      snackbar: false,
      timeout: 1500,
      mdiShareVariant,
      mdiCards,
      mdiClose,
      mdiHistory,
      mdiForum,
      mdiDramaMasks,
      mdiSnowflake,
      mdiEggEaster,
      history: null
    }
  },
  name: 'app',
  mixins: [update],
  components: {
    Presentation,
    CarbonBadge,
    History,
    Stats
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    redirectToNext() {
      let newLocation = window.location.href.replace("https://lets-vote.netlify.app/#/", "https://letsvote.dev/room/")
      newLocation = newLocation.replace("http://localhost:8080/#/", "https://letsvote.dev/room/")

      window.location.href = newLocation
    },
    toggleHistory() { 
      if(this.$store.state.drawer === false)
        this.$socket.emit('history', this.$router.currentRoute.path.slice(1))
      
      this.$store.commit('toggleDrawer')
    },
    toggleChat: function () {
      this.$store.commit('resetUnreadMessages')
      this.$store.commit('toggleChat')
    },
    toggleSettings: function () {
      this.$store.commit('toggleSettings')
    },
    toggleChristmas: function () {
      if (this.$store.state.holidaysMode !== 'none' )
        this.$socket.emit('changeHolidaysMode', { mode: 'none' })
      else
        this.$socket.emit('changeHolidaysMode', { mode: 'christmas' })
    },
    toggleEaster: function () {
      if (this.$store.state.holidaysMode !== 'none' )
        this.$socket.emit('changeHolidaysMode', { mode: 'none' })
      else
        this.$socket.emit('changeHolidaysMode', { mode: 'easter' })
    },
    goToHome: function () {
      router.push({name: 'main'}).catch(() => {})
      this.$socket.close()
      this.$store.commit('disableDrawer')
    },
    copyToClipboard: function () {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.snackbar = true
      })
    },
    inTable: function () {
      return this.$router.currentRoute.name === 'table'
    },
    itsChristmas: function () {
      return this.$store.state.holidaysMode === 'christmas'
    },
    itsEaster: function () {
      return this.$store.state.holidaysMode === 'easter'
    },
    nearChristmas: function () {
      const date = new Date()
      return date.getMonth() === 11
    },
    nearEaster: function () {
      const date = new Date()
      return date.getMonth() === 3
    },
    getColor: function() {
      if(this.itsChristmas() && this.inTable())
        return "red"
      else if(this.itsEaster() && this.inTable())
        return "#FFC107"
      return "primary"
    },
    getSantaImage: function() {
      return require('@/assets/santa.png')
    },
    getBunnyImage: function() {
      return require('@/assets/bunny.png')
    },
    getBunnyHideImage: function() {
      return require('@/assets/hide_bunny.png')
    }
  },
  sockets: {
    rounds(history) {
      this.history = history
    }
  }
}
</script>

<style>
main {
  text-align: center;
  color: white;
}

.easter {
  background-color: #FFECB3;
}

#hidebunny {
  position: absolute;
  rotate: 90deg;
  margin-left: -15px;
  margin-top: 100px;
}

#copied {
  padding-top: 50px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#about {
  color: white;
  text-decoration: none;
  font-size: 18px;
  margin-right: 20px;
  font-weight: 500
}

#about:hover {
  color: whitesmoke;
}

#wcb.wcb-d #wcb_a {
  color: white !important;
}

#wcb_2 {
  color: #4676be !important;
}

#wcb.carbonbadge {
  --b1: #4676be !important;
  --b2: #4676be !important;
}

#wcb #wcb_2, #wcb #wcb_a, #wcb #wcb_g {
  font-family: inherit !important;
}

#wcb #wcb_a, #wcb #wcb_g {
  padding: .5em 1.3em !important
}

.wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(farthest-corner at 30vw 20vh, #7397a1 1%, #3e373e 100%);
}

.snow {
  border-radius: 50%;
  opacity: 0.8;
  position: absolute;
  top: -100vh;
  animation-name: fall;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.layer1 {
  width: 1.5rem;
  height: 1.5rem;
  filter: blur(1.5px);
  box-shadow: 23.5vw 42.6vh 0 -0.11rem#fff,46.3vw 50.2vh 0 -0.12rem#fff,95.8vw 34.5vh 0 -0.17rem#fff,85.3vw 37.3vh 0 -0.02rem#fff,98vw 78.5vh 0 -0.45rem#fff,10.2vw 28.4vh 0 -0.13rem#fff,57.5vw 22.8vh 0 -0.08rem#fff;
  animation-duration: 24s;
}

.layer1.a {
  animation-delay: -2s;
}

.layer2 {
  width: 1.2rem;
  height: 1.2rem;
  filter: blur(3px);
  box-shadow: 32.5vw 56.7vh 0 -0.14rem#fff,13.3vw 43.7vh 0 -0.42rem#fff,92.6vw 98.5vh 0 -0.46rem#fff,4.3vw 56.7vh 0 -0.1rem#fff,66.1vw 37.1vh 0 -0.16rem#fff,88.1vw 81.7vh 0 -0.42rem#fff,15.2vw 52vh 0 -0.34rem#fff,83vw 26.3vh 0 -0.25rem#fff,13.3vw 21.8vh 0 -0.19rem#fff,19.8vw 93.3vh 0 -0.07rem#fff,13vw 49.2vh 0 -0.07rem#fff,64.6vw 69.7vh 0 -0.23rem#fff,71vw 81.2vh 0 -0.26rem#fff,54.6vw 48.2vh 0 -0.15rem#fff,27.1vw 91.8vh 0 -0.17rem#fff,97.4vw 99.5vh 0 -0.47rem#fff,54.6vw 15.2vh 0 -0.42rem#fff,39.6vw 85vh 0 -0.2rem#fff,74.9vw 92.8vh 0 -0.5rem#fff,69.7vw 34.1vh 0 -0.32rem#fff,50.5vw 33vh 0 -0.33rem#fff,82.4vw 46.7vh 0 -0.21rem#fff,60vw 18.8vh 0 -0.34rem#fff,45.7vw 31.8vh 0 -0.14rem#fff,86.5vw 45.2vh 0 -0.12rem#fff,94.5vw 85.8vh 0 -0.11rem#fff,35.8vw 55vh 0 -0.17rem#fff,20.6vw 63.3vh 0 -0.46rem#fff,39.8vw 50.3vh 0 -0.44rem#fff,56.3vw 84.5vh 0 -0.08rem#fff,29.3vw 72.9vh 0 -0.17rem#fff,22vw 13vh 0 -0.19rem#fff,0.9vw 79vh 0 -0.5rem#fff,27.9vw 22.3vh 0 -0.31rem#fff,58.5vw 35.5vh 0 -0.05rem#fff,89vw 65.5vh 0 -0.06rem#fff,2.8vw 97.8vh 0 -0.33rem#fff,63.4vw 44.8vh 0 -0.17rem#fff,19.7vw 70.5vh 0 -0.02rem#fff,44.9vw 72.9vh 0 -0.17rem#fff,79.8vw 91vh 0 -0.43rem#fff,69.8vw 69.1vh 0 -0.44rem#fff,69.8vw 30vh 0 -0.14rem#fff,1.4vw 10.5vh 0 -0.24rem#fff,8vw 78.5vh 0 -0.38rem#fff,30.9vw 23.8vh 0 -0.44rem#fff,40vw 10.3vh 0 -0.03rem#fff,0.1vw 53vh 0 -0.03rem#fff,87.3vw 33.3vh 0 -0.34rem#fff,74.2vw 22vh 0 -0.32rem#fff,79.5vw 88.5vh 0 -0.42rem#fff,84.4vw 47.3vh 0 -0.04rem#fff,37.1vw 24.9vh 0 -0.35rem#fff,19.2vw 48.1vh 0 -0.21rem#fff,43.2vw 13.8vh 0 -0.46rem#fff,80.8vw 54vh 0 -0.39rem#fff,61.2vw 15.5vh 0 -0.04rem#fff,46.2vw 67.8vh 0 -0.31rem#fff,62.2vw 64.6vh 0 -0.18rem#fff,43.6vw 23.8vh 0 -0.28rem#fff,64vw 31.1vh 0 -0.18rem#fff,14.7vw 40.5vh 0 -0.19rem#fff,40.4vw 83.2vh 0 -0.24rem#fff,11.9vw 7.4vh 0 -0.24rem#fff;
  animation-duration: 32s;
}

.layer2.a {
  animation-delay: -2s;
}

.layer3 {
  width: 0.8rem;
  height: 0.8rem;
  filter: blur(6px);
  box-shadow: 14.5vw 35.9vh 0 -0.46rem#fff,14.1vw 41.5vh 0 -0.37rem#fff,46.9vw 24.8vh 0 -0.29rem#fff,60.3vw 41.9vh 0 -0.41rem#fff,96.2vw 61.2vh 0 -0.44rem#fff,66.1vw 45vh 0 -0.23rem#fff,79.1vw 30.3vh 0 -0.06rem#fff,37.9vw 35.1vh 0 -0.5rem#fff,67.9vw 67.8vh 0 -0.07rem#fff,70.5vw 56.7vh 0 -0.27rem#fff,52.1vw 68.5vh 0 -0.27rem#fff,71.2vw 62.7vh 0 -0.33rem#fff,82.5vw 29vh 0 -0.47rem#fff,63.7vw 53.7vh 0 -0.45rem#fff,0.1vw 86.6vh 0 -0.33rem#fff,77.3vw 11.9vh 0 -0.05rem#fff,30.2vw 89.8vh 0 -0.36rem#fff,77vw 75.1vh 0 -0.4rem#fff,57.8vw 63.3vh 0 -0.41rem#fff,55vw 4.4vh 0 -0.23rem#fff,43.3vw 88.1vh 0 -0.3rem#fff,33.6vw 88.6vh 0 -0.08rem#fff,78.5vw 79.3vh 0 -0.19rem#fff,90.9vw 60.5vh 0 -0.45rem#fff,99.8vw 68.2vh 0 -0.37rem#fff,60.9vw 56.8vh 0 -0.17rem#fff,43.7vw 10.8vh 0 -0.09rem#fff,69vw 19.1vh 0 -0.18rem#fff,48.7vw 70.2vh 0 -0.42rem#fff,75.8vw 18.7vh 0 -0.43rem#fff,74vw 39.8vh 0 -0.35rem#fff,96.4vw 69vh 0 -0.43rem#fff,66.9vw 89.6vh 0 -0.24rem#fff,69.5vw 37.1vh 0 -0.38rem#fff,5.6vw 66.4vh 0 -0.28rem#fff,90.5vw 88.6vh 0 -0.09rem#fff,28.5vw 93.8vh 0 -0.18rem#fff,1.1vw 66.8vh 0 -0.28rem#fff,4.6vw 70.4vh 0 -0.08rem#fff,74.9vw 89.6vh 0 -0.23rem#fff,74.2vw 34.7vh 0 -0.1rem#fff,13.3vw 5vh 0 -0.1rem#fff,26.2vw 50.9vh 0 -0.32rem#fff,9.3vw 52.7vh 0 -0.18rem#fff,15.3vw 42.2vh 0 -0.49rem#fff,95.7vw 6vh 0 -0.44rem#fff,45.5vw 17.8vh 0 -0.25rem#fff,9.4vw 29.1vh 0 -0.01rem#fff,48.6vw 83.6vh 0 -0.06rem#fff,54.7vw 73.7vh 0 -0.04rem#fff,13.8vw 82.3vh 0 -0.28rem#fff,2.6vw 77.3vh 0 -0.43rem#fff,45.5vw 95.5vh 0 -0.13rem#fff,58.1vw 5.5vh 0 -0.14rem#fff,27.9vw 77.7vh 0 -0.5rem#fff,17.7vw 38.9vh 0 -0.02rem#fff,93.4vw 75.4vh 0 -0.26rem#fff,49vw 41.4vh 0 -0.02rem#fff,92.1vw 85.4vh 0 -0.24rem#fff,95.1vw 39.7vh 0 -0.42rem#fff,21.3vw 34.3vh 0 -0.4rem#fff,72.6vw 47.1vh 0 -0.02rem#fff,74.4vw 71.1vh 0 -0.41rem#fff,66vw 24.5vh 0 -0.49rem#fff,25.1vw 11.6vh 0 -0.04rem#fff,11.4vw 29.8vh 0 -0.11rem#fff,12.2vw 15.3vh 0 -0.02rem#fff,32.2vw 61.3vh 0 -0.41rem#fff,92.2vw 1.1vh 0 -0.11rem#fff,48.2vw 9.4vh 0 -0.25rem#fff,64.9vw 5.7vh 0 -0.46rem#fff,46.7vw 3.2vh 0 -0.11rem#fff,91.6vw 53.8vh 0 -0.24rem#fff,39.6vw 48.9vh 0 -0.47rem#fff,77.7vw 2.7vh 0 -0.46rem#fff,87.3vw 17.4vh 0 -0.21rem#fff,46.4vw 97.7vh 0 -0.36rem#fff,98.2vw 32.9vh 0 -0.39rem#fff,78.6vw 4.4vh 0 -0.09rem#fff,56.3vw 91.4vh 0 -0.23rem#fff,12.3vw 14.5vh 0 -0.38rem#fff,6.1vw 45.4vh 0 -0.41rem#fff,4.1vw 86vh 0 -0.4rem#fff,43.7vw 18.1vh 0 -0.08rem#fff,39.5vw 9.9vh 0 -0.11rem#fff,64vw 70.7vh 0 -0.49rem#fff,5.6vw 43.9vh 0 -0.29rem#fff,93.9vw 78.5vh 0 -0.06rem#fff,88.7vw 57.7vh 0 -0.33rem#fff,63.5vw 71.4vh 0 -0.06rem#fff,20.5vw 77.2vh 0 -0.44rem#fff,94.6vw 98.8vh 0 -0.11rem#fff,60.8vw 11.5vh 0 -0.1rem#fff,29.7vw 59.1vh 0 -0.17rem#fff,46.3vw 36.4vh 0 -0.41rem#fff,80.9vw 27.2vh 0 -0.24rem#fff,61.5vw 48.6vh 0 -0.35rem#fff,3.7vw 4.8vh 0 -0.24rem#fff,21.4vw 25.6vh 0 -0.5rem#fff,95.8vw 5.5vh 0 -0.38rem#fff,15.1vw 63.1vh 0 -0.1rem#fff,41.1vw 27.4vh 0 -0.05rem#fff,90.2vw 62.8vh 0 -0.34rem#fff,69vw 72.3vh 0 -0.31rem#fff,10.5vw 44.1vh 0 -0.41rem#fff,35.4vw 40.7vh 0 -0.26rem#fff,81.3vw 80.4vh 0 -0.32rem#fff,84.9vw 71.3vh 0 -0.4rem#fff,68.2vw 45vh 0 -0.19rem#fff,28.9vw 26.4vh 0 -0.04rem#fff,1.2vw 30.5vh 0 -0.15rem#fff,60.9vw 42.3vh 0 -0.37rem#fff,26.3vw 86.7vh 0 -0.21rem#fff,14vw 59.9vh 0 -0.09rem#fff,48.9vw 7vh 0 -0.1rem#fff,96.6vw 3.6vh 0 -0.2rem#fff,80.7vw 1.4vh 0 -0.21rem#fff,70.2vw 15.6vh 0 -0.33rem#fff,90.1vw 94.8vh 0 -0.38rem#fff,99vw 38.7vh 0 -0.2rem#fff,52.5vw 85.1vh 0 -0.38rem#fff,76.5vw 15vh 0 -0.07rem#fff,93.6vw 5.8vh 0 -0.32rem#fff,96.1vw 41.3vh 0 -0.12rem#fff,14.1vw 2.8vh 0 -0.5rem#fff,44vw 39.7vh 0 -0.42rem#fff,75.8vw 93.4vh 0 -0.35rem#fff,59.4vw 75.8vh 0 -0.12rem#fff,51.6vw 79.1vh 0 -0.05rem#fff,95.3vw 16.5vh 0 -0.16rem#fff,26.6vw 30.3vh 0 -0.34rem#fff,51.3vw 1vh 0 -0.48rem#fff,28.9vw 81.5vh 0 -0.15rem#fff,50.1vw 63.8vh 0 -0.19rem#fff,8.7vw 1.4vh 0 -0.26rem#fff,95.4vw 8.1vh 0 -0.48rem#fff,28.1vw 95.2vh 0 -0.34rem#fff,50.1vw 9vh 0 -0.29rem#fff,7.1vw 42.7vh 0 -0.06rem#fff,33.6vw 0.6vh 0 -0.05rem#fff,46.1vw 44.8vh 0 -0.12rem#fff,31.8vw 90.8vh 0 -0.46rem#fff,21.3vw 82.4vh 0 -0.03rem#fff,40.8vw 94.1vh 0 -0.17rem#fff,43.6vw 71.5vh 0 -0.05rem#fff,30.4vw 33.3vh 0 -0.07rem#fff,89.1vw 14.9vh 0 -0.29rem#fff,46.7vw 7vh 0 -0.11rem#fff,44.6vw 24.9vh 0 -0.03rem#fff,31.1vw 39.1vh 0 -0.05rem#fff,60.4vw 57.6vh 0 -0.01rem#fff,45.3vw 87.9vh 0 -0.12rem#fff,1.2vw 56.8vh 0 -0.49rem#fff,32.6vw 28.9vh 0 -0.35rem#fff,15.5vw 82.6vh 0 -0.03rem#fff,49.6vw 30.1vh 0 -0.43rem#fff,67.2vw 30.4vh 0 -0.17rem#fff,30.6vw 93.3vh 0 -0.41rem#fff,27.9vw 16.4vh 0 -0.05rem#fff,17.6vw 54.8vh 0 -0.39rem#fff,56vw 45.3vh 0 -0.39rem#fff,60vw 9.8vh 0 -0.14rem#fff,24.5vw 67.4vh 0 -0.34rem#fff,29vw 19.7vh 0 -0.44rem#fff,98.9vw 70.5vh 0 -0.27rem#fff,53.6vw 82.7vh 0 -0.47rem#fff,17.1vw 96.2vh 0 -0.27rem#fff,93.3vw 73.5vh 0 -0.38rem#fff,81.3vw 23.6vh 0 -0.5rem#fff,6.1vw 51vh 0 -0.47rem#fff,0.6vw 99.3vh 0 -0.36rem#fff,58.7vw 36.9vh 0 -0.22rem#fff,26.1vw 93.3vh 0 -0.34rem#fff,96.6vw 93.1vh 0 -0.04rem#fff,84.8vw 84.6vh 0 -0.13rem#fff,75.1vw 1.4vh 0 -0.28rem#fff,43.9vw 5.4vh 0 -0.27rem#fff,90.8vw 87.3vh 0 -0.21rem#fff,66.4vw 69vh 0 -0.07rem#fff,87.1vw 6.5vh 0 -0.28rem#fff,87.4vw 41.8vh 0 -0.4rem#fff,10.6vw 65.5vh 0 -0.33rem#fff,61vw 23.3vh 0 -0.3rem#fff,30.8vw 14.1vh 0 -0.3rem#fff,83.9vw 35.1vh 0 -0.22rem#fff,31vw 85.3vh 0 -0.15rem#fff,40.5vw 89.7vh 0 -0.04rem#fff,40.4vw 63.7vh 0 -0.04rem#fff,78vw 36.7vh 0 -0.08rem#fff,87.5vw 77vh 0 -0.41rem#fff,78.9vw 27.2vh 0 -0.48rem#fff,32.9vw 94.4vh 0 -0.39rem#fff,10.7vw 19.6vh 0 -0.07rem#fff,35.3vw 7.4vh 0 -0.31rem#fff,48.8vw 6.4vh 0 -0.31rem#fff,69.8vw 78.5vh 0 -0.37rem#fff,41.1vw 59.1vh 0 -0.26rem#fff,96.8vw 27.5vh 0 -0.24rem#fff,45.9vw 20.2vh 0 -0.2rem#fff,53.8vw 62vh 0 -0.11rem#fff,79.5vw 2.3vh 0 -0.5rem#fff,69.2vw 81.8vh 0 -0.5rem#fff,85.2vw 54vh 0 -0.4rem#fff,82.2vw 37vh 0 -0.3rem#fff,58.3vw 9.3vh 0 -0.3rem#fff,51.9vw 62.4vh 0 -0.3rem#fff,27vw 19.2vh 0 -0.16rem#fff,95.6vw 1.6vh 0 -0.31rem#fff,82.4vw 81.5vh 0 -0.15rem#fff,58.1vw 13vh 0 -0.01rem#fff,68.1vw 36.4vh 0 -0.45rem#fff,86.1vw 48.7vh 0 -0.44rem#fff,79.8vw 3.9vh 0 -0.45rem#fff,48.6vw 88.1vh 0 -0.33rem#fff,66.5vw 76.4vh 0 -0.45rem#fff,90.7vw 62.2vh 0 -0.27rem#fff,84.9vw 94.2vh 0 -0.15rem#fff,82.1vw 40vh 0 -0.15rem#fff,52.1vw 63.9vh 0 -0.22rem#fff,43vw 88.5vh 0 -0.2rem#fff,66.2vw 37.5vh 0 -0.19rem#fff,78.4vw 96.2vh 0 -0.08rem#fff,3.1vw 49.2vh 0 -0.4rem#fff,93.7vw 26.2vh 0 -0.01rem#fff,72.6vw 63.8vh 0 -0.18rem#fff,30.4vw 94.5vh 0 -0.36rem#fff,38.3vw 40.2vh 0 -0.31rem#fff,72.8vw 15.5vh 0 -0.07rem#fff,5.9vw 54vh 0 -0.34rem#fff,6.4vw 1.9vh 0 -0.4rem#fff,82vw 37.7vh 0 -0.37rem#fff,50.9vw 9vh 0 -0.02rem#fff,33.2vw 48.5vh 0 -0.11rem#fff,77.6vw 7vh 0 -0.27rem#fff,47.9vw 3.1vh 0 -0.04rem#fff,45vw 79.4vh 0 -0.44rem#fff,73.9vw 64.1vh 0 -0.05rem#fff,38.3vw 96.9vh 0 -0.38rem#fff,50.9vw 84.6vh 0 -0.42rem#fff,32.2vw 24.5vh 0 -0.41rem#fff,5.3vw 54.3vh 0 -0.21rem#fff,73.4vw 8.5vh 0 -0.08rem#fff,70.6vw 85.4vh 0 -0.35rem#fff,69.8vw 55.6vh 0 -0.42rem#fff,83.2vw 13.1vh 0 -0.05rem#fff,47.3vw 74.9vh 0 -0.14rem#fff,87.5vw 76.9vh 0 -0.44rem#fff,66.4vw 71.8vh 0 -0.16rem#fff,41.2vw 40vh 0 -0.36rem#fff,95.3vw 21.2vh 0 -0.02rem#fff,95.5vw 49.3vh 0 -0.15rem#fff,53.2vw 90.6vh 0 -0.22rem#fff,87vw 37.8vh 0 -0.47rem#fff,98.6vw 24.9vh 0 -0.12rem#fff,64.8vw 19.3vh 0 -0.1rem#fff,40.9vw 83.2vh 0 -0.22rem#fff,42.9vw 32.5vh 0 -0.38rem#fff,40vw 7.9vh 0 -0.19rem#fff,95.7vw 15.1vh 0 -0.49rem#fff,45.6vw 59.1vh 0 -0.42rem#fff,9.7vw 34.8vh 0 -0.07rem#fff,92.8vw 86.7vh 0 -0.18rem#fff,5.6vw 25.4vh 0 -0.34rem#fff,54.1vw 30.8vh 0 -0.06rem#fff,15.8vw 29.3vh 0 -0.19rem#fff,18.1vw 60.9vh 0 -0.06rem#fff,49vw 65.9vh 0 -0.2rem#fff,92.4vw 95.1vh 0 -0.38rem#fff,4vw 73.6vh 0 -0.27rem#fff,65.7vw 32.4vh 0 -0.45rem#fff,9.6vw 24.3vh 0 -0.37rem#fff,89.6vw 99.9vh 0 -0.11rem#fff,23vw 32.3vh 0 -0.29rem#fff,49.1vw 60.4vh 0 -0.26rem#fff,79.6vw 59.1vh 0 -0.47rem#fff,33.2vw 79.4vh 0 -0.25rem#fff,26.5vw 14.2vh 0 -0.22rem#fff,50.2vw 59.7vh 0 -0.25rem#fff,33vw 72.6vh 0 -0.01rem#fff,5.6vw 63.1vh 0 -0.42rem#fff,25.1vw 84.8vh 0 -0.26rem#fff,38.8vw 3.3vh 0 -0.18rem#fff,2vw 79.1vh 0 -0.45rem#fff,68.3vw 19.2vh 0 -0.31rem#fff,70.4vw 49.2vh 0 -0.13rem#fff,56.8vw 83.8vh 0 -0.04rem#fff,0.3vw 22.3vh 0 -0.36rem#fff,33.4vw 19.5vh 0 -0.28rem#fff,55.1vw 66.8vh 0 -0.5rem#fff,4.3vw 50.4vh 0 -0.23rem#fff,51.9vw 27.8vh 0 -0.19rem#fff,52vw 86.2vh 0 -0.2rem#fff,57.4vw 42vh 0 -0.11rem#fff,20.3vw 20.3vh 0 -0.22rem#fff,76.3vw 46.3vh 0 -0.28rem#fff,24.7vw 46.9vh 0 -0.33rem#fff,85.9vw 62.9vh 0 -0.27rem#fff,0.3vw 23.2vh 0 -0.3rem#fff,41.2vw 17.3vh 0 -0.26rem#fff,30.1vw 79.5vh 0 -0.17rem#fff;
  animation-duration: 40s;
}

.layer3.a {
  animation-delay: -3s;
}

@keyframes fall {
  10% {
    transform: translate(1vw, 20vh);
  }
  20% {
    transform: translate(0vw, 40vh);
  }
  30% {
    transform: translate(-1vw, 60vh);
  }
  40% {
    transform: translate(0vw, 80vh);
  }
  50% {
    transform: translate(1vw, 100vh);
  }
  60% {
    transform: translate(0vw, 120vh);
  }
  70% {
    transform: translate(-1vw, 140vh);
  }
  80% {
    transform: translate(0vw, 160vh);
  }
  90% {
    transform: translate(1vw, 180vh);
  }
  100% {
    transform: translate(0vw, 200vh);
  }
}

.holidaysBtn {
 animation-name: holidaysBtn;
 animation-duration: 3s;
}

#santa {
  margin-right: 80px;
  animation-name: santa;
  animation-duration: 5s;
  animation-fill-mode: forwards;
  z-index: 3;
}

#bunny {
  margin-right: 10px;
  margin-bottom: 8px;
  animation: bunny 2s linear alternate;
  animation-fill-mode: forwards;
  z-index: 3;
}

@keyframes santa {
  100% {
    transform: translateX(500px);
  }
}

@keyframes bunny {
  0%    {transform: translate3d(0,0,0) scale3d(1,1,1);}
  10%   {transform: translate3d(0,10%,0) scale3d(.8,1.2,1) translateX(10px);}
  20%   {transform: translate3d(0,20%,0) scale3d(1.2,.8,1) translateX(20px);}
  30%   {transform: translate3d(0,0,0) scale3d(1,1,1) translateX(30px);}
  40%   {transform: translate3d(0,10%,0) scale3d(.8,1.2,1) translateX(40px);}
  50%   {transform: translate3d(0,20%,0) scale3d(1.2,.8,1) translateX(50px);}
  60%   {transform: translate3d(0,0,0) scale3d(1,1,1) translateX(60px);}
  70%   {transform: translate3d(0,10%,0) scale3d(.8,1.2,1) translateX(70px);}
  80%   {transform: translate3d(0,20%,0) scale3d(1.2,.8,1) translateX(80px); opacity: .8; }
  90%   {transform: translate3d(0,0,0) scale3d(1,1,1) translateX(90px); opacity: 0;}
  100%  {transform: translate3d(0,10%,0) scale3d(.8,1.2,1) translateX(500px); opacity: 0;}
}

@keyframes holidaysBtn {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
